<div mat-dialog-title>
  <su-headline h="h3" skin="primary">{{ data.title }}</su-headline>
</div>

<div mat-dialog-content>
  <form [formGroup]="form" style="margin-top: 20px">
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"></formly-form>
  </form>
</div>

<div
  mat-dialog-actions
  style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  ">
  <su-button
    *ngIf="data.isEditMode"
    skin="secondary"
    [label]="
      'accountingArea.accounting_areas.edit_dialog.set_inactive' | translate
    "
    (onClick)="validateForm('delete')">
  </su-button>
  <div style="display: flex; gap: 8px; margin-left: auto">
    <su-button
      skin="secondary"
      [label]="'shared.cancel' | translate"
      (onClick)="onCancel()"
      mat-dialog-close></su-button>
    <su-button
      skin="primary"
      [label]="'shared.save' | translate"
      (onClick)="validateForm('save')"></su-button>
  </div>
</div>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
